/**
 * This file is auto-generated from ChatNotFound.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const title: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Chat not found';
        case 'pl':
            return 'Nie znaleziono czatu';
    }
};

export const subtitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return "The conversation you're looking for doesn't exist or has been removed. Start a new chat to get help.";
        case 'pl':
            return 'Rozmowa, której szukasz, nie istnieje lub została usunięta. Rozpocznij nowy czat, aby uzyskać pomoc.';
    }
};

export const startNewChat: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Start new chat';
        case 'pl':
            return 'Rozpocznij nowy czat';
    }
};
